import PropTypes from 'prop-types';
import React, {Component} from 'react';

const propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    customClassName: PropTypes.string,
    placeholderText: PropTypes.string
};

class CustomDatepickerInput extends Component {
    render() {
        const {value, onClick, customClassName, placeholderText} = this.props;

        let v = (value != undefined && value.length > 0) ? value : placeholderText;

        return (
            <div onClick={onClick} className={customClassName !== undefined ? customClassName : ""}>
                <input type="text" className="react-datepicker-ignore-onclickoutside" value={v} style={{border: "none", width: "75px"}}/>
            </div>
        )
    }
}

CustomDatepickerInput.propTypes = propTypes;

export default CustomDatepickerInput;



// WEBPACK FOOTER //
// ./src/components/Base/CustomDatepickerInput.js